/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
==========================================================================================*/
import axios from '@/axios.js'
export default {


  fetchMunicipalitiesData ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${axios.defaults.baseURL  }/municipalities`)
        .then((response) => {
          commit('SET_MUNICIPALITY', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })

  },
  fetchCitiesData ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${axios.defaults.baseURL  }/cities`)
        .then((response) => {
          commit('SET_CITIES', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })

  },
  fetchRegionData ({ commit }, city_id) {

    return new Promise((resolve, reject) => {
      axios.get(`${axios.defaults.baseURL  }/regions/${city_id}`)
        .then((response) => {
          commit('SET_REGIONS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })

  }


}
